import { put } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, marketId) => {
    return await put(`/basket/${basketId}/market/${marketId}`, {});
};
